import React from 'react';
import Spinner from '../audi-ui-components/Spinner';

class Loader extends React.Component {
    render() {
        return (
            <div style={{position: 'relative', minHeight: this.props.minHeight}}>
                <div className="spinner-wrapper">
                    <div className="spinner-inner">
                        <Spinner isContinuous />
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

Loader.defaultProps = {
    minHeight: '300px'
};

export default Loader;
